import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppFilter } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { FormBuilderService } from '../../../services';
import { MessageTemplateService } from '../../../services';
import { ActivatedRoute } from '@angular/router';
declare var tinymce: any;
declare var files: any;
import {
  MessageNewModal,
  // TemplateNewModal
} from '../../../modals';
import { FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-message-template-detail',
  templateUrl: './message-template-detail.component.html',
  styleUrls: ['./message-template-detail.component.scss'],
})
export class MessageTemplateDetailComponent implements OnInit {
  pending: boolean;
  success: any;
  error: any;
  fieldArrays: Array<any> = [];
  // tinyoption = {
  //   base_url: '/tinymce',
  //   suffix: '.min',
  //   license_key: 'gpl',
  //   height: 350 /* the height you want your editor box to be*/,
  //   plugins: [
  //     'insertdatetime',
  //     'link',
  //     'preview',
  //     'searchreplace',
  //     'table',
  //     'anchor',
  //     'image',
  //     'lists',
  //     'advlist',
  //     'autolink',
  //     'charmap',
  //     'print',
  //     'preview',
  //     'anchor',
  //     'searchreplace',
  //     'visualblocks',
  //     'code',
  //     'fullscreen',
  //     'insertdatetime',
  //     'media',
  //     'table',
  //     'paste',
  //     'imagetools',
  //     'wordcount',
  //   ],
  // };
  // option = {
  //   height: 300,
  //   plugins: [
  //     'advlist autolink lists link image charmap print preview anchor',
  //     'searchreplace visualblocks code fullscreen',
  //     'insertdatetime media table paste imagetools wordcount',
  //   ],
  //   toolbar:
  //     'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
  //   /* enable title field in the Image dialog*/
  //   image_title: true,
  //   file_picker_types: 'image',
  //   /* and here's our custom image picker*/
  //   file_picker_callback: function (cb, value, meta) {
  //     let self = this;
  //     var input = document.createElement('input');
  //     input.setAttribute('type', 'file');
  //     input.setAttribute('accept', 'image/*');

  //     input.onchange = function (e?: Event) {
  //       var file = (<HTMLInputElement>e.target).files[0];

  //       var reader: any = new FileReader();
  //       reader.onload = function () {
  //         /*
  //         Note: Now we need to register the blob in TinyMCEs image blob
  //         registry. In the next release this part hopefully won't be
  //         necessary, as we are looking to handle it internally.
  //       */
  //         var id = 'blobid' + new Date().getTime();
  //         var blobCache = tinymce.activeEditor.editorUpload.blobCache;
  //         var str: any = reader.result;
  //         var base64 = str.split(',')[1];
  //         var blobInfo = blobCache.create(id, file, base64);
  //         blobCache.add(blobInfo);

  //         /* call the callback and populate the Title field with the file name */
  //         cb(blobInfo.blobUri(), { title: file.name });
  //       };
  //       reader.readAsDataURL(file);
  //     };

  //     input.click();
  //   },
  //   extended_valid_elements:
  //     'iframe[src|title|width|height|allowfullscreen|frameborder|class|id]',
  //   content_style:
  //     'body { font-family:Century Gothic,Helvetica,Arial,sans-serif; font-size:14px }',
  // };
  changed: boolean;
  option = {
    base_url: '/tinymce',
    suffix: '.min',
    height: 600,
    plugins: [
      'insertdatetime',
      'link',
      'preview',
      'searchreplace',
      'table',
      'anchor',
      'image',
      'lists',
    ],
    toolbar:
      'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
    /* enable title field in the Image dialog*/
    image_title: true,
    file_picker_types: 'image',
    /* and here's our custom image picker*/
    file_picker_callback: function (cb, value, meta) {
      let self = this;
      var input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');

      input.onchange = function (e?: Event) {
        var file = (<HTMLInputElement>e.target).files[0];

        var reader: any = new FileReader();
        reader.onload = function () {
          /*
          Note: Now we need to register the blob in TinyMCEs image blob
          registry. In the next release this part hopefully won't be
          necessary, as we are looking to handle it internally.
        */
          var id = 'blobid' + new Date().getTime();
          var blobCache = tinymce.activeEditor.editorUpload.blobCache;
          var str: any = reader.result;
          var base64 = str.split(',')[1];
          var blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);

          /* call the callback and populate the Title field with the file name */
          cb(blobInfo.blobUri(), { title: file.name });
        };
        reader.readAsDataURL(file);
      };

      input.click();
    },
    extended_valid_elements:
      'iframe[src|title|width|height|allowfullscreen|frameborder|class|id]',
    content_style:
      'body { font-family:Century Gothic,Helvetica,Arial,sans-serif; font-size:14px }',
  };
  bodies: FormGroup = new FormGroup({
    mailTemplate: new FormControl(''),
    smsTemplate: new FormControl(''),
    notifcationTemlate: new FormControl(''),
  });
  messageTemplateId: string;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'messageTemplateName',
        op: 'cn',
        data: '',
      },
    ],
  };
  filter: AppFilter = new AppFilter();
  template;
  constructor(
    private location: Location,
    private modalService: SuiModalService,
    private formBuilder: FormBuilderService,
    private route: ActivatedRoute,
    private messageTemplateSvc: MessageTemplateService
  ) {
    this.changed = false;
    this.filter = new AppFilter({ sidx: 'messageTemplateId', rows: 10 });
    this.messageTemplateId = this.route.snapshot.paramMap.get('id');
    this.searchFilter.rules[0].data = this.messageTemplateId;
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.getPage(1);
  }

  getPage(page) {
    this.messageTemplateSvc
      .getMessageTemplate({ id: this.messageTemplateId })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.template = res;
          console.log(this.template, 'template');
          this.bodies.patchValue({
            mailTemplate: this.template.mailTemplate,
            smsTemplate: this.template.smsTemplate,
            notifcationTemlate: this.template.notifcationTemlate,
          });
          console.log(this.bodies.value, 'money');
          this.bodies.valueChanges.subscribe((e) => {
            this.changed = true;
          });
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  editMessage() {
    this.modalService
      .open(
        new MessageNewModal(
          'Edit Message Template',
          this.template,
          true,
          ModalSize.Tiny
        )
      )
      .onApprove((eq) => {
        // this.selectedCertificateHolder = eq;
        // this.startApplication(eq);
        this.getPage(1);
      })
      .onDeny(() => console.log('add certificate holder cancel'));
  }
  update() {
    this.pending = true;
    let body = {
      actionAdditionalDetails: this.template.actionAdditionalDetails,
      emailEnabled: this.template.emailEnabled,
      mailSubject: this.template.mailSubject,
      mailTemplate: this.template.mailTemplate,
      messageTemplateDescription: this.template.messageTemplateDescription,
      messageTemplateName: this.template.messageTemplateName,
      notifcationSubject: this.template.notifcationSubject,
      notifcationTemlate: this.template.notifcationTemlate,
      smsEnabled: this.template.smsEnabled,
      smsSubject: this.template.smsSubject,
      smsTemplate: this.template.smsTemplate,
    };
    let newBody = { ...this.template, ...this.bodies.value };
    this.messageTemplateSvc
      .UpdateMessageTemplate({
        messageTemplateId: this.template.messageTemplateId,
        body: newBody,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Message template updated successfully';
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  goBack() {
    this.location.back();
  }
  ngOnInit(): void {}
}
